module.exports = __webpack_public_path__ + "img/cedaci-img.050cf8b2.jpg";